import React from "react";
import { FieldHeading } from "./FieldHeading.js";

type Props = {
  vatExpense: number;
};

/**
 * Generates table rows for the VAT report field 12.
 */
export const VatReportField12 = ({ vatExpense }: Props) => {
  return (
    <FieldHeading
      label="Väli 12"
      description="Tasumisele kuuluv käibemaks"
      total={vatExpense}
      itemsCount={0}
    />
  );
};
